import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import styled from 'styled-components';

export type LinkProps = RouterLinkProps & {
  className?: string;
  children: React.ReactNode;
  $active?: boolean;
};

const StyledLink = styled(RouterLink) <{ $active?: boolean }>`
  color: inherit;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const Link: React.FC<LinkProps> = ({ children, $active, ...props }) => {
  return <StyledLink $active={$active} {...props}>{children}</StyledLink>;
}; 